import { useRecordContext } from "react-admin"

export const BillTitle = () => {
  const record = useRecordContext()

  if (!record) return null

  return <span>{record.unique_number ?? record.id} [Bill]</span>
}
